import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-row gap-2 rounded-xl p-4" }
const _hoisted_2 = { class: "flex flex-col gap-1 w-1/2" }
const _hoisted_3 = { class: "text-xs font-semibold text-black-lp-100" }
const _hoisted_4 = { class: "flex flex-col gap-1 w-1/2" }
const _hoisted_5 = { class: "text-xs font-semibold text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("cargoV2.components.common.destinationCityTitle")), 1),
      _createVNode(_component_SelectSearch, {
        class: "mt-1.5",
        options: _ctx.destinationCityOptions,
        isLoading: _ctx.isLoadingDestinationCity,
        keyName: "label",
        keyValue: "code",
        placeholder: _ctx.$t('cargoV2.components.common.selectDestinationCity'),
        onFocus: _ctx.fetchDestinationCity,
        onFilter: _ctx.fetchDestinationCity,
        modelValue: _ctx.form.destinationCityCode,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.destinationCityCode = $event)),
        onChange: _ctx.resetCargoTypes
      }, null, 8, ["options", "isLoading", "placeholder", "onFocus", "onFilter", "modelValue", "onChange"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("cargoV2.components.common.transportMode")), 1),
      _createVNode(_component_SelectSearch, {
        class: "mt-1.5",
        isLoading: _ctx.isLoadingCargoType,
        options: _ctx.cargoTypeOptions,
        keyName: "label",
        keyValue: "value",
        placeholder: _ctx.$t('cargoV2.components.common.selectMode'),
        modelValue: _ctx.form.cargoType,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.cargoType = $event)),
          _ctx.onSelectModa
        ]
      }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "onUpdate:modelValue"])
    ])
  ]))
}